import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "../../utils/tailwindUtils";

/**
 * Lightweight breadcrumb for roster sub-screens.
 * @param {{ items: { label: string, href?: string }[], className?: string }} props
 */
const RosterBreadcrumb = ({ items, className }) => (
    <nav
        aria-label="Breadcrumb"
        className={cn("flex flex-wrap items-center gap-1 px-3 pb-2 text-xs text-muted-foreground", className)}
    >
        {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
                <span key={`${item.label}-${index}`} className="inline-flex items-center gap-1">
                    {index > 0 && <ChevronRight className="h-3 w-3 shrink-0 opacity-60" />}
                    {item.href && !isLast ? (
                        <Link
                            to={item.href}
                            className="font-medium text-sidebar dark:text-gray-100 hover:text-sidebar-primary hover:underline"
                        >
                            {item.label}
                        </Link>
                    ) : (
                        <span className={cn(isLast && "font-semibold text-foreground")}>
                            {item.label}
                        </span>
                    )}
                </span>
            );
        })}
    </nav>
);

export default RosterBreadcrumb;
